<template>
  <dl class="fr-my-0">
    <slot></slot>
  </dl>
</template>

<script setup lang="ts">
</script>
